module.exports = __webpack_public_path__ + "img/5.da66c5d3.jpg";